<template>
<div>
  <!--<Navbar />-->
  <div class="content-i">
    <div class="content-box">
      <div class="element-wrapper">
        <h6 class="element-header">{{ t('whoisonlineTitle', 'whoisonlineTitle')}}</h6>
        <div class="element-box">
          <div class="element-info">
            <div class="row align-items-center">
              <div class="col-sm-8">
                <div class="element-info-with-icon">
                  <div class="element-info-icon">
                    <div class="os-icon os-icon-users">
                    </div>
                  </div>
                  <div class="element-info-text">
                    <h5 class="element-inner-header">{{ t('whoisonlineHeader', 'whoisonlineHeader')}}</h5>
                    <div class="element-inner-desc">{{ t('whoisonlineDesc','whoisonlineDesc') }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="input-group col-lg-2 col-md-4 col-sm-12 mb-2 mb-md-0">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                      {{ t('recordsPerPageText','recordsPerPageText') }}
                  </div>
                </div>
                <input class="form-control" type="text" v-model="perPage" :placeholder="perPage">
            </div>
            <div class="col-lg-2 col-md-3 col-sm-12 mb-2 mb-md-0">
              <b-input-group>
                  <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
                  <b-input-group-append>
                      <b-button :disabled="!filter" @click.prevent="filter = ''">{{ t('clearButtonText','clearButtonText') }}</b-button>
                  </b-input-group-append>
              </b-input-group>
            </div>
          </div>
          <hr>
          <b-table id="onlineusers-table" striped hover bordered :fields="fields" :busy.sync="isBusy" :items="onlineUsers" :per-page="perPage" :currentPage="currentPage" :filter="filter" @filtered="onFiltered">
            <template class="busy-row" slot="table-busy" slot-scope="items" v-bind:value="onlineUsers">
              <vcl-table :rows="parseInt(perPage)" :columns="6"></vcl-table>
            </template>
            <!-- Added translatable table headers and timezone to last login header, PW -->
            <template v-slot:head(email)="data">
              <span >{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:head(customers)="data">
              <span >{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:head(last_login)="data">
              <span >{{ t(data.label, data.label) }} (GMT)</span>
            </template>
            <template v-slot:head(logged_in_for)="data">
              <span >{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:head(last_request)="data">
              <span >{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:head(last_host)="data">
              <span >{{ t(data.label, data.label) }}</span>
            </template>
            <template v-slot:cell(customers)="data">
              <div v-if="data.item.customers" v-for="customer in data.item.customers" :key="customer.id">
                <li class="list-unstyled">
                  <router-link :to="{ path: `/customers_accounts/manage_customers?page=1&per_page=20&customerReference=` + `${customer.reference}`}">{{ customer.reference}}</router-link>
                </li>
              </div>
              <span v-if="data.item.customers === undefined || (data.item.customers.length == 0)"> - </span>
            </template>
            <template v-slot:cell(last_login)="data" >
              <span type="text"> {{ data.item.last_login | clientDateFormatter(datePickerFormat)}}</span>
            </template>
            <template v-slot:cell(logged_in_for)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.logged_in_for | formatDate}}</span>
            </template>
            <template v-slot:cell(last_request)="data" >
              <span type="text" class="text-capitalize"> {{ data.item.last_request | formatDate }}</span>
            </template>
            <template v-slot:cell(last_host)="data" >
              <span v-if="data.item.last_host"> {{ data.item.last_host }} </span>
              <span v-else> - </span>
            </template>
          </b-table>
          <div class="row">
            <div class="offset-md-8 col-md-4 offset-lg-8 col-lg-4 mb-2 mb-md-0">
                <p>&nbsp;</p>
                <b-pagination class="float-right mb-0" v-model="currentPage" :total-rows="onlineUsersRows" :per-page="perPage" aria-controls="onlineusers-table" v-if="getOnlineUsers.length > 0"></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar'
import { mapGetters } from 'vuex'
import moment from 'moment'
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { VclTable } from 'vue-content-loading'

export default {
    name: 'whosonline',
    components:{
        Navbar,
        VclTable
    },
    data () {
      return {
          // NS-10081 Added translatable table headers, PW
          fields: [
              {key: 'email', label:'tableHeadEmailAddress', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'customers', label: 'tableHeadUserCustomers', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'last_login', label: 'tableHeadUserLastLogin', sortable: true, thClass: 'hover-pointer brand-color'},
              {key: 'logged_in_for', label: 'tableHeadUserLoggedInFor', sortable: false, thClass: 'brand-color'},
              {key: 'last_request', label:'tableHeadUserIdleFor', sortable: false, thClass: 'brand-color'},
              {key: 'last_host', label: 'tableHeadUserHost', sortable: true, thClass: 'hover-pointer brand-color'}
          ],
          currentPage: 1,
          perPage: 20,
          filter: null,
          isBusy: false
      }
    },
    methods: {
      onFiltered(filteredItems) {
          this.totalRows = filteredItems.length
          this.currentPage = 1
      },
      getAllOnlineUsers() {
        this.isBusy = true
        this.$store.dispatch('getAllOnlineUsers', {
          currentPage: this.currentPage,
          perPage: this.perPage
        }).then(() => {
          this.isBusy = false
        })

        // NS-9774. added condition to prevent request if the previous one hasnt finished, PW
        this.onlineUsersInterval = setInterval( () => {
          if(!this.isBusy) {
            this.isBusy = true
            this.$store.dispatch('getAllOnlineUsers', {
              currentPage: this.currentPage,
              perPage: this.perPage
            }).then(() => {
              this.isBusy = false
            })
          }
        }, 60000)
      }
    },
    computed:{
        ...mapGetters(['getOnlineUsers', 'getUserDetails', 'getUserLevel']),
        onlineUsers:{
            get() {
                return this.$store.getters.getOnlineUsers
            }
        },
        onlineUsersRows:{
            get() {
                return this.$store.getters.getOnlineUsers.length
            }
        },
        datePickerFormat() {
          if(this.$store.getters.allTemplateDetails && this.$store.getters.allTemplateDetails.datePickerFormat) {
            let dateformat = this.$store.getters.allTemplateDetails.datePickerFormat.replace(/-/g, ' ')
            return dateformat
          } else {
            return "DD-MM-YYYY"
          }
        }
    },
    created() {
        this.getAllOnlineUsers()
    },
    beforeDestroy() {
        clearInterval(this.onlineUsersInterval)
    },
    filters:{
        formatDate: function(date) {
          // NS-11203, Displays the exact time for the "LOGGED IN FOR" and "IDLE FOR" columns, RS
          const now  = new Date();
          return moment.utc(moment(now,"YYYY-MM-DD, h:mm:ss").diff(moment(date,"YYYY-MM-DD, h:mm:ss"))).format("HH:mm:ss");
        },
        humanReadable: function(date) {
          return moment(date).format('MMMM Do YYYY, h:mm:ss a');
        },
        clientDateFormatter: function(date, datePickerFormat) {
          return moment(date).format(datePickerFormat + ' h:mm:ss')
        }
    }
}

</script>

<style scoped>
  table >>> tbody, table >>> thead{
    text-align: center;
  }
  .table  >>> .brand-color {
    background-color: #047bf8 !important;
    color: white !important;
  }
</style>
